import React, { useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate
} from 'react-router-dom';
import DetectDevice from "./utils/detectDevice";
import Navbar from './components/navbar';
import Footer from './components/footer';
import CookieConsent from './components/cookies';
import Main from './views/main';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import Blog from './views/blog';
import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const { mobile } = DetectDevice();

  const TrackPageViews = () => {
    const location = useLocation();
    useEffect(() => {
      if (window.gtag) {
        window.gtag('config', 'G-BTNW8QBWNY', {
          page_path: location.pathname,
        });
      }
    }, [location]);
    return null;
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BTNW8QBWNY';
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };

    window.gtag('js', new Date());
    window.gtag('config', 'G-BTNW8QBWNY');
  }, []);

  return (
    <BrowserRouter basename="/secured-ai-based-vulnerability-assessment-tool-for-enterprise">
      <TrackPageViews />
      <div className="App">
        <div className="main text-white">
          <Navbar />
          <CookieConsent />
          <div className={`${mobile ? '' : 'container'}`}>
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/home" element={<Main />} />
              <Route path="/*" element={<Navigate to="/" />} />              
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;